import PropTypes from 'prop-types';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination
} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { UserListHead, UserListToolbar } from '../user';

const TABLE_HEAD = [
  { id: 'name', label: 'Company', alignRight: false },
  { id: 'id', label: 'Company ID', alignRight: false },
  { id: 'teamsCount', label: 'Teams', alignRight: false }
];

const styles = {
  tableContainer: { minWidth: 900 },
  row: { cursor: 'pointer' },
  companyName: { color: '#0067b2' },
  notFoundCell: { py: 3 }
};

BillingTable.propTypes = {
  companies: PropTypes.array.isRequired,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  totalCount: PropTypes.number,
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  onRequestSort: PropTypes.func
};

BillingTable.defaultProps = {
  rowsPerPage: 10,
  page: 1,
  totalCount: 0,
  totalPages: 1,
  onPageChange: () => {},
  onRowsPerPageChange: () => {},
  filterName: '',
  onFilterName: () => {},
  order: 'asc',
  orderBy: 'name',
  onRequestSort: () => {}
};

export default function BillingTable({
  companies,
  page,
  rowsPerPage,
  totalCount,
  totalPages,
  onPageChange,
  onRowsPerPageChange,
  filterName,
  onFilterName,
  order,
  orderBy,
  onRequestSort
}) {
  const navigate = useNavigate();

  const isNotFound = companies.length === 0;

  const handleRowClick = (companyId) => {
    navigate(`/billing/company/${companyId}`);
  };

  return (
    <Card>
      <UserListToolbar
        placeholder="Search company, company ID, or contact email..."
        filterName={filterName}
        onFilterName={onFilterName}
      />

      <Scrollbar>
        <TableContainer sx={styles.tableContainer}>
          <Table>
            <UserListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={totalCount}
              onRequestSort={onRequestSort}
            />
            <TableBody>
              {companies.map((row) => (
                <TableRow hover key={row.id} sx={styles.row} onClick={() => handleRowClick(row.id)}>
                  <TableCell align="left">
                    <strong style={styles.companyName}>{row.name}</strong>
                  </TableCell>
                  <TableCell align="left">{row.id}</TableCell>
                  <TableCell align="left">{row.teamsCount}</TableCell>
                </TableRow>
              ))}
              {isNotFound && (
                <TableRow>
                  <TableCell align="center" colSpan={3} sx={styles.notFoundCell}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={Math.max(page - 1, 0)}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        backIconButtonProps={{ disabled: page <= 1 }}
        nextIconButtonProps={{ disabled: page >= totalPages }}
      />
    </Card>
  );
}
